import styled from '@emotion/styled';
import {Submit as SubmitUI, SlideTitle as SlideTitleUI, colors} from 'ui';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: 80,
  backgroundColor: colors.greyLight,
});

export const Title = styled(SlideTitleUI)({
  color: 'black',
  marginTop: 46,
  marginBottom: 30,
});

export const Button = styled(SubmitUI)({
  margin: '0 auto',
});
